import { render, staticRenderFns } from "./DeleteMessageModal.vue?vue&type=template&id=8c976bb4&scoped=true&"
import script from "./DeleteMessageModal.vue?vue&type=script&lang=js&"
export * from "./DeleteMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteMessageModal.vue?vue&type=style&index=0&id=8c976bb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c976bb4",
  null
  
)

export default component.exports